import { ca } from '@cian/analytics';

import { TUserAnalytics } from '../../types/currentUser';

export function trackOpenNewReviewForm({ user }: { user: TUserAnalytics }) {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'NewbuildingReviews',
    action: 'Show_sopr',
    label: 'Review_Screen1_rating',
    useLastProducts: true,
    user,
  });
}
